import { createAction } from "@reduxjs/toolkit"


export const updatePoolResults = createAction<{
    numberAuto: number
  }>('earn/updatePoolResults')